/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-header{padding:unset!important;border-bottom:unset!important}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle;border:none}"];
export { styles as styles };
